import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
@Injectable()
export class CookieInterceptor implements HttpInterceptor {
  constructor(private cookie: CookieService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //var cookie = this.cookie.get('data');
    var cookiedata = window.localStorage.getItem('data');
    var hdr = req.headers;
    hdr.set('content-type', 'plain/text');
    // const request = req.clone({
    //   headers: new HttpHeaders({
    //     ...req.headers,
    //     'content-type': 'plain/text',
    //     data: cookiedata,
    //   }),
    //   withCredentials: true,
    // });
    const authReq = req.clone({
      headers: req.headers.set('data', cookiedata),
      withCredentials: true,
    });
    console.log({ httpInterceprot: authReq, cookie: cookiedata });
    return next.handle(authReq);
  }
}
